<template>
  <div class="page-header">
    <h1>{{ title }}</h1>

    <div class="subtitle" v-if="subtitle">
      {{ subtitle }}
    </div>

    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    }
  }
}
</script>

<style scoped>
h1 {
  margin: 15px 0 0 0;
  color: #32404d;
  font-size: 19px;
  font-weight: normal;
}

.subtitle {
  margin-top: 4px;
  font-weight: 500;
}

.page-header {
  padding: 11px 22px 0 22px;
  text-align: center;
}

>>> .actions .el-button {
  margin-top: 10px;
  width: 250px;
}

>>> .actions .el-button + .el-button {
  margin-left: 10px;
}

>>> .actions .el-button + a {
  margin-left: 10px;
}

>>> .actions a + .el-button {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageHeader.vue